import { render, staticRenderFns } from "./GroupPriceIncreasedModal.vue?vue&type=template&id=5a61efa0&"
import script from "./GroupPriceIncreasedModal.vue?vue&type=script&lang=js&"
export * from "./GroupPriceIncreasedModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupPriceIncreasedModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports